import React from "react";
import styled, { css } from "styled-components";

const Content = styled.div`
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

const Wrapper = styled.div`
  display: block;
  overflow: hidden;
  position: relative;
  ${props =>
    props.rightPadding &&
    css`
      ${Content} {
        padding-right: ${props.rightPadding}rem;
      }
    `};
`;

export const Ratio = styled.div`
  display: block;
  padding-bottom: ${props =>
    props.ratio ? `calc(${props.ratio} * 100%)` : `100%`};
`;

const RatioBox = props => (
  <Wrapper rightPadding={props.rightPadding} innerRef={props.innerRef}>
    <Ratio ratio={props.ratio} />
    <Content>{props.children}</Content>
  </Wrapper>
);

export default RatioBox;
